import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { images, recentBuyers } from '../data/content';
const FIRST_DELAY = 6000;
const SHOW_FOR = 5500;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutes(Math.floor(Math.random() * 12) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), SHOW_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-24 z-50 flex justify-start sm:inset-x-auto sm:left-5" data-id="element-277" data-mp="1164p8a24l03x">
      <AnimatePresence data-id="element-278" data-mp="1fv0rfqhi3iwm">
        {visible && !dismissed && <motion.div role="status" className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_rgba(38,12,72,0.25)] ring-1 ring-brand-100" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-279" data-mp="1awfuq11gjhcx">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-brand-50 object-contain" data-id="element-280" data-mp="28jyb9y1d1nrh" />
            <div className="min-w-0" data-id="element-281" data-mp="23m67a5nfyb6x">
              <p className="text-sm font-extrabold text-brand-950" data-id="element-282" data-mp="23l3ko9x5iuwt">
                {buyer.name} <span className="font-medium text-brand-900/70" data-id="element-283" data-mp="2anrynerhvqm6">from {buyer.country}</span>
              </p>
              <p className="text-sm text-brand-900/80" data-id="element-284" data-mp="2fm38vqlpc34x">just purchased the digital Roadmap™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-mint-700" data-id="element-285" data-mp="2knaf3l874u9h">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-286" data-mp="2plbx02tvynjd" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-brand-900/50 hover:text-brand-950" aria-label="Close notification" data-id="element-287" data-mp="1wwdciz2aj9aw">
              <XIcon className="h-4 w-4" data-id="element-288" data-mp="26osw20t8k5xw" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}